module.exports = "/cyber/_next/static/images/regionSteamIn-4ef6b09c3198bb9ba2c643c5d5c918da.jpg";